<template>
    <div id="BuscadorInventarioIndex">
        <buscador-productos-presentacion-rango v-model="filterData" :catsMain="catsMain" />
        <b-row id="BuscadorInventarioIndex">
            <b-col id="controlPanelHolderContent">
                <productos-presentacion-rango v-model="filterData" :route="$route" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BuscadorProductosPresentacionRango from './BuscadorProductosPresentacionRango.vue'
import ProductosPresentacionRango from './ProductosPresentacionRango.vue'
export default {
    name: 'BuscadorInventarioIndex',
    components: {BuscadorProductosPresentacionRango, ProductosPresentacionRango},
    computed: {
        ...mapGetters(['uiGetBuscadorPresentacionRangedCfg', "uiGetCategoriasFiltro", "isLogged"]),
        catsMain() {
			let ret = [
				{
					value: "*",
					text: "-- Todas las categorías --",
				},
			];
			_.forEach(this.uiGetCategoriasFiltro, (cat) => {
				ret.push({
					value: cat.cat_id_pk,
					text: cat.cat,
				});
			});
			return _.uniqBy(ret, "value");
		},
    },
    data: () => {
        return{
            filterData: {
                categoria: '*',
                presentacionIdPk: null,
                rangeStart: null,
                rangeEnd: null,
            }
        } 
    },
    methods: {
        ...mapMutations(['uiSetBuscadorPresentacionRangedCfg']),
        ...mapActions(["updateCategoriasFiltro"]),
    },
    watch: {
        filterData(){
            this.uiSetBuscadorPresentacionRangedCfg(this.filterData)
        }
    },
    beforeMount(){
        
        this.isLoading = true;

		let init = async () => {
			// SIEMPRE ACTUALIZAMOS LA LISTA DE CATEGORÍAS, PERO SOLO ESPERAMOS LA UI CUANDO NO HAYA UNA PRECARGA.
			if (!this.uiGetCategoriasFiltro.length)
				await this.updateCategoriasFiltro();
			this.filterData = _.clone(this.uiGetBuscadorPresentacionRangedCfg)
			this.isLoading = false;
		}

		if(this.isLogged){
			init()
		} else {
			setTimeout(init, 1250)
		}
    }
}
</script>